import { Navigate, type RouteObject } from 'react-router-dom';

import { CoachInterviewLayout } from './CoachInterviewLayout';
import { CoachInterviewShareLayout } from './CoachInterviewShareLayout';
import { CoachRootLayout } from './CoachRootLayout';

export const coachRoutes: RouteObject = {
  path: 'coach',
  element: <CoachRootLayout />,
  children: [
    { index: true, element: <Navigate to="new" replace /> },
    {
      path: 'new',
      children: [
        { index: true, element: <Navigate to="onboarding" replace /> },
        {
          path: 'onboarding',
          lazy: () => import('../../app/coach/new/onboarding'),
        },
        {
          path: 'overview',
          lazy: () => import('../../app/coach/new/overview'),
        },
        {
          path: 'job-description',
          lazy: () => import('../../app/coach/new/job-description'),
        },
        {
          path: 'user-information',
          lazy: () => import('../../app/coach/new/user-information'),
        },
      ],
    },

    {
      path: 'interview',
      element: <CoachInterviewLayout />,
      children: [
        {
          path: 'sample-question',
          lazy: () => import('../../app/coach/interview/sample-question'),
        },
        {
          path: 'questions',
          lazy: () => import('../../app/coach/interview/questions'),
        },
        {
          path: 'result',
          lazy: () => import('../../app/coach/interview/result'),
        },
        {
          path: 'result-status',
          lazy: () => import('../../app/coach/interview/result-status'),
        },
        {
          path: 'technical-problem',
          lazy: () => import('../../app/coach/interview/technical-problem'),
        },
      ],
    },
    {
      path: 'share',
      element: <CoachInterviewShareLayout />,
      children: [
        {
          index: true,
          lazy: () => import('../../app/coach/interview/share'),
        },
      ],
    },
    {
      path: 'share/mobile',
      element: <CoachInterviewShareLayout />,
      children: [
        {
          index: true,
          lazy: () => import('../../app/coach/interview/share-mobile'),
        },
      ],
    },
  ],
};
